export var DropdownAlignment;
(function (DropdownAlignment) {
    DropdownAlignment["center"] = "center";
})(DropdownAlignment || (DropdownAlignment = {}));
export var DropdownTheme;
(function (DropdownTheme) {
    DropdownTheme["Line"] = "line";
    DropdownTheme["Box"] = "box";
})(DropdownTheme || (DropdownTheme = {}));
export var DropdownOptionTextOverflow;
(function (DropdownOptionTextOverflow) {
    DropdownOptionTextOverflow["ellipsis"] = "ellipsis";
    DropdownOptionTextOverflow["wrap"] = "wrap";
})(DropdownOptionTextOverflow || (DropdownOptionTextOverflow = {}));
//# sourceMappingURL=types.js.map